import api from './client'
import type { DashboardReview, PerformanceDashboard, Project, ProjectValueDashboard, WorkloadEntry } from '../types'

export const workloadApi = {
  getDashboard: (params: { startDate: string; endDate: string; employeeId?: string }) =>
    api.get<{ data: DashboardReview }>('/dashboard', { params }),

  getPerformance: (params: { startDate: string; endDate: string; employeeId?: string }) =>
    api.get<{ data: PerformanceDashboard }>('/performance', { params }),

  getWorkload: () => api.get<{ data: WorkloadEntry[] }>('/workload'),

  getProjectWorkload: (projectId: string) =>
    api.get<{ data: WorkloadEntry[] }>(`/projects/${projectId}/workload`),

  listProjectValueProjects: () =>
    api.get<{ data: Array<Pick<Project, 'id' | 'name' | 'identifier' | 'color' | 'description' | 'showOnDashboard'>> }>('/project-values/projects'),

  getProjectValueDashboard: (projectId: string, params: { startDate: string; endDate: string }) =>
    api.get<{ data: ProjectValueDashboard }>(`/project-values/projects/${projectId}`, { params }),
}
